'use strict';

const GoogleTagManager = {
    pushToDataLayer: function (payload) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(payload);
    },

    trackEvent: function (analyticsData) {
        const payload = {
            event: 'trackEvent',
            eventCategory: analyticsData.category || '',
            eventAction: analyticsData.action || '',
            eventLabel: analyticsData.label || '',
            eventValue: analyticsData.value || '0',
            eventNonInteractive: this._isNonInteractive(analyticsData),
            hitCallback: analyticsData.hitCallback
        };

        if (analyticsData.memberId > 0) {
            payload['memberId'] = analyticsData.memberId.toString();
        }

        this.pushToDataLayer(payload);
    },

    trackPageView: function () {
        const payload = {
            event: 'trackPageview',
            customPageUrl: window.location.pathname + window.location.hash
        };
        this.pushToDataLayer(payload);
    },

    _isNonInteractive: function (analyticsData) {
        if (analyticsData.userTriggered === undefined) {
            return true;
        }
        return !analyticsData.userTriggered;
    }
};

export default GoogleTagManager;
